import { MfsFluidVolatileSession } from './mfsFluidVolatileSession';

const APP_ID_KEY = 'appId';

/**
 * A Fluid {@link DataObject} implementation for mfs system properties. To ensure backwards compatibility with existing
 * pods, the volatile session data object, which by itself doesn't store any persistent data, is being extended by
 * MfsFluidSystemDataStore so it can use the data object.
 */
export class MfsFluidSystemDataStore extends MfsFluidVolatileSession {
  /** Get the application id of the container */
  getAppId(): string | undefined {
    return this.root.get(APP_ID_KEY);
  }

  /** Set the application id of the container */
  setAppId(appId: string): void {
    this.root.set(APP_ID_KEY, appId);
  }
}
